import gate from '@/api/axios';

export const register = async (payload) => gate.post('/contractor/registration/register', payload);
export const requestConfirmationCode = async (payload) => gate.post('/contractor/registration/request', payload);
export const checkCode = async (payload) => gate.post('/contractor/registration/checkCode', payload);
export const suggest = async (inn) => gate.get(`/contractor/registration/suggest/${encodeURIComponent(inn)}`);
export const verify = async (payload) => gate.post('/emailVerification/verify', payload);

export const requestMobileIdToken = async (payload) => gate.post('/contractor/mobile-id/token', payload);
export const verifyMobileId = async (payload) => gate.post('/contractor/mobile-id/siteverify', payload);
export const duplicateGoogleSheet = async (payload) => gate.post('/contractor/registration/google-sheet-duplicate', payload);
